import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

import { HelperWrapper } from 'src/components'
import { AssociationsWithActions } from 'src/components/associations-with-actions'
import { useAccountImpactsSelection } from 'src/hooks'
import { AssociationsType, IAccountFormUpdate, IFormSelectedImpacts } from 'src/types'

interface IProps {
  isDisabled?: boolean
}

const ImpactsAssociationInput = ({ isDisabled }: IProps) => {
  const [t] = useTranslation()
  const { values, setFieldValue } = useFormikContext<IAccountFormUpdate>()

  const setSelectedImpacts = (selectedImpacts: IFormSelectedImpacts[]) =>
    setFieldValue('selectedImpacts', selectedImpacts)

  const { handleSelectedImpacts, selectedImpactsIcons } = useAccountImpactsSelection(
    values.selectedImpacts,
    setSelectedImpacts,
  )

  const impactActions = [
    {
      lable: <HelperWrapper t="show-on-home-page-label" isColorInherited size={12} />,
      isShow: (id: string) => {
        const impact = values.selectedImpacts.find((impact) => impact.id === id)
        return impact ? impact.home_page_show : false
      },
      handleSwitch: (id: string) => {
        const impactIndex = values.selectedImpacts.findIndex((impact) => impact.id === id)

        if (impactIndex !== -1) {
          const updatedImpacts = [...values.selectedImpacts]

          updatedImpacts[impactIndex] = {
            ...updatedImpacts[impactIndex],
            home_page_show: !updatedImpacts[impactIndex].home_page_show,
          }

          setFieldValue('selectedImpacts', updatedImpacts)
        }
      },
    },
    {
      lable: <HelperWrapper t="show-on-impacts-page-label" isColorInherited size={12} />,
      isShow: (id: string) => {
        const impact = values.selectedImpacts.find((impact) => impact.id === id)
        return impact ? impact.impact_page_show : false
      },
      handleSwitch: (id: string) => {
        const impactIndex = values.selectedImpacts.findIndex((impact) => impact.id === id)

        if (impactIndex !== -1) {
          const updatedImpacts = [...values.selectedImpacts]

          updatedImpacts[impactIndex] = {
            ...updatedImpacts[impactIndex],
            impact_page_show: !updatedImpacts[impactIndex].impact_page_show,
          }

          setFieldValue('selectedImpacts', updatedImpacts)
        }
      },
    },
    {
      lable: <HelperWrapper t="show-on-account-page-label" isColorInherited size={12} />,
      isShow: (id: string) => {
        const impact = values.selectedImpacts.find((impact) => impact.id === id)
        return impact ? impact.account_page_show : false
      },
      handleSwitch: (id: string) => {
        const impactIndex = values.selectedImpacts.findIndex((impact) => impact.id === id)

        if (impactIndex !== -1) {
          const updatedImpacts = [...values.selectedImpacts]

          updatedImpacts[impactIndex] = {
            ...updatedImpacts[impactIndex],
            account_page_show: !updatedImpacts[impactIndex].account_page_show,
          }

          setFieldValue('selectedImpacts', updatedImpacts)
        }
      },
    },
  ]

  return (
    <AssociationsWithActions
      disabled={isDisabled}
      setSelectedItems={setSelectedImpacts}
      type={AssociationsType.IMPACTSWITHACTION}
      description={<HelperWrapper t="impacts-association-title" isColorInherited size={12} />}
      selectedItems={values.selectedImpacts}
      handleSelectItem={handleSelectedImpacts}
      selectedIcons={selectedImpactsIcons}
      actions={impactActions}
      withDnd
    />
  )
}

export { ImpactsAssociationInput }
